import { useAppZones } from '~/composables/use-app-zones'

/**
 * Полная перезагрузка при программном переходе между зонами
 * навигация в рамках зоны остаётся SPA.
 * @see https://nextjs.org/docs/app/guides/multi-zones#linking-between-zones
 * @see ~/composables/use-app-zones.ts - реестр зон и isOwnRoute
 */
export default defineNuxtRouteMiddleware((to, from) => {
  if (import.meta.server) return

  const { isOwnRoute } = useAppZones()

  if (!isOwnRoute(from.path) || isOwnRoute(to.path)) return

  return navigateTo(to.fullPath, { external: true })
})
